module.exports = "img {\n  vertical-align: baseline; }\n\ndiv {\n  display: inline;\n  font-size: 16px; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/blur/blur.component.scss
// module id = 673
// module chunks = 0